
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[uid]",
      function () {
        return require("private-next-pages/users/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[uid]"])
      });
    }
  